/* eslint-disable prettier/prettier */
/**
 * @author yangjay
 * @description xAxis、yAxis 配置文件
 */
import { axisPositionOpts, positionOpts } from './common'

export const genAxisConfig = (prefix, chartType) => {
  const upperPrefix = prefix.toUpperCase()
  const isXAxis = upperPrefix === 'X'
  const xCrossLayoutCharts = ['bar']
  const position = xCrossLayoutCharts.includes(chartType)
    ? (isXAxis ? 'right': 'bottom')
    : (isXAxis ? 'bottom' : 'left')

  const posPickOpts =
    isXAxis * !xCrossLayoutCharts.includes(chartType) ? ['top', 'bottom'] : ['left', 'right']

  const axisFormData = {
    [`${prefix}AxisVisible`]: true,
    [`${prefix}AxisPosition`]: position,
    [`${prefix}AxisGridVisible`]: false,
    [`${prefix}AxisTitleVisible`]: false,
    [`${prefix}AxisTitleText`]: `${upperPrefix}轴标题`,
    [`${prefix}AxisTitleColor`]: '#fff',
    [`${prefix}AxisTitleLocation`]: 'end',
    [`${prefix}AxisTitleFontSize`]: 14,
    [`${prefix}AxisLineVisible`]: true,
    [`${prefix}AxisLineStroke`]: '#fff',
    [`${prefix}AxisLineWidth`]: 1,
    [`${prefix}AxisLabelVisible`]: true,
    [`${prefix}AxisLabelStroke`]: '#fff',
    [`${prefix}AxisLabelRotate`]: '',
    [`${prefix}AxisLabelFontSize`]: 12
  }

  const axisConfig = [
    {
      info: { title: `${upperPrefix}轴设置(axis)` },
      fields: [
        { title: `${upperPrefix}轴显示`, name: `${prefix}AxisVisible`, type: 'switch' },
        {
          title: `${upperPrefix}轴位置`,
          name: `${prefix}AxisPosition`,
          type: 'select',
          options: positionOpts(posPickOpts)
        },
        { title: '显示网格线', name: `${prefix}AxisGridVisible`, type: 'switch' },
        {
          info: { title: '标题' },
          fields: [
            { title: '标题显示', name: `${prefix}AxisTitleVisible`, type: 'switch' },
            { title: '标题', name: `${prefix}AxisTitleText`, type: 'input' },
            { title: '标题颜色', name: `${prefix}AxisTitleColor`, type: 'color' },
            {
              title: '标题位置',
              name: `${prefix}AxisTitleLocation`,
              type: 'select',
              options: axisPositionOpts
            },
            { title: '字体大小', name: `${prefix}AxisTitleFontSize`, type: 'number' }
          ].map((item) => {
            const visible =
              item.name === `${prefix}AxisTitleVisible`
                ? null
                : (item) => item[`${prefix}AxisTitleVisible`]
            visible && (item.visible = visible)
            return { ...item }
          }),
          visible: (item) => item[`${prefix}AxisVisible`]
        },
        {
          info: { title: '轴线' },
          fields: [
            { title: '轴线显示', name: `${prefix}AxisLineVisible`, type: 'switch' },
            { title: '轴线颜色', name: `${prefix}AxisLineStroke`, type: 'color' },
            { title: '轴线线宽', name: `${prefix}AxisLineWidth`, type: 'number' }
          ].map((item) => {
            const visible =
              item.name === `${prefix}AxisLineVisible`
                ? null
                : (item) => item[`${prefix}AxisLineVisible`]
            visible && (item.visible = visible)
            return { ...item }
          }),
          visible: (item) => item[`${prefix}AxisVisible`]
        },
        {
          info: { title: '标签' },
          fields: [
            { title: '标签显示', name: `${prefix}AxisLabelVisible`, type: 'switch' },
            { title: '标签颜色', name: `${prefix}AxisLabelStroke`, type: 'color' },
            { title: '旋转角度', name: `${prefix}AxisLabelRotate`, type: 'number' },
            { title: '字体大小', name: `${prefix}AxisLabelFontSize`, type: 'input' }
          ].map((item) => {
            const visible =
              item.name === `${prefix}AxisLabelVisible`
                ? null
                : (item) => item[`${prefix}AxisLabelVisible`]
            visible && (item.visible = visible)
            return { ...item }
          }),
          visible: (item) => item[`${prefix}AxisVisible`]
        }
      ]
    }
  ]

  return { axisFormData, axisConfig }
}

export function calcAxisData(options, prefix) {
  let calcData = {}
  if (options[`${prefix}AxisVisible`]) {
    //
    calcData = {
      top: true,
      nice: true, // 是否美化
      position: options[`${prefix}AxisPosition`],
      title: options[`${prefix}AxisTitleVisible`]
        ? {
          text: options[`${prefix}AxisTitleText`],
          position: options[`${prefix}AxisTitleLocation`],
          style: {
            fill: options[`${prefix}AxisTitleColor`],
            fontSize: options[`${prefix}AxisTitleFontSize`]
          }
        }
        : null,
      // 标签
      label: options[`${prefix}AxisLabelVisible`]
        ? {
          rotate: options[`${prefix}AxisLabelRotate`],
          style: {
            fill: options[`${prefix}AxisLabelStroke`],
            fontSize: options[`${prefix}AxisLabelFontSize`]
          }
        }
        : null,
      // 网格线
      grid: options[`${prefix}AxisGridVisible`]
        ? {
          line: {
            style: {
              stroke: '#c1c1c1',
              lineWidth: 1,
              strokeOpacity: 0.4,
              shadowColor: 'black',
              shadowBlur: 10,
              shadowOffsetX: 5,
              shadowOffsetY: 5,
              cursor: 'pointer'
            }
          }
        }
        : null,
      // 轴线
      line: options[`${prefix}AxisLineVisible`]
        ? {
          style: {
            stroke: options[`${prefix}AxisLineStroke`],
            lineWidth: options[`${prefix}AxisLineWidth`]
          }
        }
        : null
    }
  } else {
    calcData = false
  }
  return calcData
}
